import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, inject } from 'Mri.Web.Common';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { LinkContainer } from 'react-router-bootstrap';
import { Route } from 'react-router-dom';
import { Button } from 'reactstrap';
import { AppStore } from '../../../Core/AppStore';
import { DisplaysStore } from '../../DisplaysStore';
import { AdminSettings } from './AdminSettings';
import { DeviceControlSettings } from './DeviceControlSettings';
import { DisplayConfiguration } from './DisplayConfiguration';
import { VideoInputSettings } from './VideoInputSettings';

export interface IDisplaySettingsViewParams {
    readonly serialNumber: string;
}
export interface IDisplaySettingsViewProps extends RouteComponentProps<IDisplaySettingsViewParams> {}

@autoinject
@observer
export class DisplaySettingsView extends React.Component<IDisplaySettingsViewProps> {
    @action
    public async componentDidMount() {
        this.loading = true;

        try {
            await this.displaysStore.loadDisplaySettingsAsync(this.props.match.params.serialNumber);
        } catch (e: any) {
            this.appStore.alertHandle.setError(e);
        } finally {
            this.loading = false;
        }
    }

    public render() {
        const serialNumber = this.props.match.params.serialNumber;
        return (
            <div className="container-fluid pt-3">
                <nav className="navbar navbar-expand-md navbar-light d-inline-block w-100 px-0 py-mobile-0 pb-0">
                    <ul className="nav nav-tabs me-auto border-bottom-0">
                        <li className="nav-item w-100">
                            <LinkContainer
                                exact
                                to={`/displays/${serialNumber}/settings`}
                                className="nav-link fw-bold d-inline-block"
                            >
                                <Button color="link" className="fw-bold">
                                    Device Control
                                </Button>
                            </LinkContainer>

                            <LinkContainer
                                exact
                                to={`/displays/${serialNumber}/settings/video-input`}
                                className="nav-link fw-bold d-inline-block"
                            >
                                <Button color="link" className="fw-bold">
                                    Video Input
                                </Button>
                            </LinkContainer>

                            <LinkContainer
                                exact
                                to={`/displays/${serialNumber}/settings/display-configuration`}
                                className="nav-link fw-bold d-inline-block"
                            >
                                <Button color="link" className="fw-bold">
                                    Display Configuration
                                </Button>
                            </LinkContainer>

                            <LinkContainer
                                exact
                                to={`/displays/${serialNumber}/settings/admin`}
                                className="nav-link fw-bold d-inline-block"
                            >
                                <Button color="link" className="fw-bold">
                                    Admin
                                </Button>
                            </LinkContainer>
                        </li>
                    </ul>
                </nav>

                <div className="container-fluid p-4 preferences-content rounded">
                    <div className="row">
                        <Route path="/displays/:serialNumber/settings" exact component={DeviceControlSettings} />

                        <Route
                            path="/displays/:serialNumber/settings/video-input"
                            exact
                            component={VideoInputSettings}
                        />

                        <Route
                            path="/displays/:serialNumber/settings/display-configuration"
                            exact
                            component={DisplayConfiguration}
                        />

                        <Route path="/displays/:serialNumber/settings/admin" exact component={AdminSettings} />
                    </div>
                </div>
            </div>
        );
    }
    @inject public appStore!: AppStore;
    @inject public displaysStore!: DisplaysStore;

    @observable
    private loading = false;
}
